import { useMemo } from 'react'
import { unifyAddress } from 'src/common/utils/web3/unifyAddress'
import useConfig from 'src/config/hooks/useConfig'
import useSX1155Holdings from './useSX1155Holdings'

const useOwnedGoldTokens = (accountAddress: string | undefined) => {
  const { tokensAddresses } = useConfig()

  const {
    sx1155Holdings,
    loading: sx1155HoldingsLoading,
    ...rest
  } = useSX1155Holdings({
    variables: {
      filter: {
        or: [
          {
            tokenId_contains_nocase: unifyAddress(tokensAddresses.goldKg!),
            user_contains_nocase: accountAddress,
            balance_gt: '0',
          },
          {
            tokenId_contains_nocase: unifyAddress(tokensAddresses.goldOz!),
            user_contains_nocase: accountAddress,
            balance_gt: '0',
          },
        ],
      },
    },
    skip: !tokensAddresses.goldKg || !tokensAddresses.goldOz || !accountAddress,
  })

  return useMemo(
    () => ({
      ownedGoldTokens: sx1155Holdings,
      loading: sx1155HoldingsLoading,
      ...rest,
    }),
    [sx1155Holdings, sx1155HoldingsLoading, rest]
  )
}

export default useOwnedGoldTokens
